// extracted by mini-css-extract-plugin
export var infoItem = "_ll-1";
export var title = "_ll-0";